import { Check, AlertTriangle } from "lucide-react";

export default function ConcreteHeroVisual() {
  return (
    <div className="w-full max-w-md overflow-hidden rounded-lg border border-border bg-secondary/20 shadow-sm">
      <div className="border-b border-border px-6 py-4">
        <p className="font-mono-tech text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          Renewal Contract &middot; $120K ACV
        </p>
      </div>
      <div className="space-y-3 px-6 py-5">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">ACV</span>
          <span className="flex items-center gap-2 font-semibold text-foreground">
            $120,000
            <Check className="h-4 w-4 text-emerald-600" />
          </span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Term</span>
          <span className="flex items-center gap-2 font-semibold text-foreground">
            12 months
            <Check className="h-4 w-4 text-emerald-600" />
          </span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Billing cadence</span>
          <span className="flex items-center gap-2 font-semibold text-foreground">
            Monthly
            <AlertTriangle className="h-4 w-4 text-destructive" />
          </span>
        </div>
      </div>
      <div className="border-t border-border bg-destructive/5 px-6 py-4">
        <p className="text-sm font-semibold text-destructive">
          Caught before billing ran
        </p>
        <p className="mt-1 text-sm text-muted-foreground">
          Billing cadence in CRM (monthly) doesn&apos;t match contract
          (annual). Flagged before invoice generated.
        </p>
      </div>
    </div>
  );
}
